"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTH_BASE_URL = exports.MANAGEMENT_URL = exports.FIRST_RIDE_NOTIFICATION_BCC_EMAILS = exports.DAYTRIP_NOTIFICATION_DISCOVER_STRING = exports.DAYTRIP_NOTIFICATION_EMAIL_STRING = exports.DAYTRIP_FEEDBACK_EMAIL_STRING = exports.DAYTRIP_CUSTOMERS_EMAIL_STRING = exports.DAYTRIP_BOOKINGS_EMAIL_STRING = exports.DAYTRIP_AGENTS_EMAIL_STRING = exports.DAYTRIP_DRIVERS_EMAIL_STRING = exports.DAYTRIP_EMAIL_STRING = exports.DAYTRIP_SYSTEM_STEPAN_VURM_EMAIL = exports.DAYTRIP_BILLING_EMAIL = exports.DAYTRIP_NOTIFICATION_EMAIL = exports.DAYTRIP_DISCOVER_EMAIL = exports.DAYTRIP_FEEDBACK_EMAIL = exports.DAYTRIP_CUSTOMERS_EMAIL = exports.DAYTRIP_DRIVERS_EMAIL = exports.DAYTRIP_BOOKINGS_EMAIL = exports.DAYTRIP_AGENTS_EMAIL = exports.DAYTRIP_EMAIL = exports.WHATSAPP_DRIVER_SUPPORT_CONTACT = exports.DRIVER_APP_SCHEMA = exports.DAYTRIP_REFERRAL_LINK = exports.DAYTRIP_SITE_URL = exports.getTravelAgentPasswordResetUrl = exports.TRAVEL_AGENT_PASSWORD_RESET_URL = exports.WEBSITE_CUSTOMER_ORDERS = exports.getWebsiteConfirmPasswordResetUrl = exports.WEBSITE_CONFIRM_PASSWORD_RESET_URL = exports.SITE_DOMAIN = exports.SITE_BASE_URL = exports.BASE_IMAGE_URL = exports.MANAGEMENT_COOKIE_PREFIX = exports.COOKIE_PREFIX = exports.PAGINATION_DEFAULT_COUNT = exports.TESTING_EMAIL = exports.MAILGUN_API_KEY = exports.MAILGUN_DOMAIN = exports.IS_LOCAL = exports.IS_DYNAMIC_OR_TEST = exports.IS_TEST = exports.IS_STAGING = exports.IS_DYNAMIC = exports.IS_DEVELOPMENT = exports.IS_PRODUCTION = exports.LOCAL_IP = exports.ENVIRONMENT = exports.Env = exports.Application = void 0;
exports.API_UPLOAD_PROFILE_PHOTO_URL = exports.API_UPLOAD_PROFILE_PHOTO_ENDPOINT = exports.API_AUTH_MAGIC_LINK_ENDPOINT = exports.API_SIGN_IN_TO_CI_AS_CUSTOMER_URL = exports.API_SIGN_IN_TO_CI_AS_CUSTOMER = exports.API_CUSTOMER_VERIFY_EMAIL_REDIRECT_URL = exports.API_CUSTOMER_VERIFY_EMAIL = exports.API_RESET_PASSWORD_ENDPOINT = exports.getRedisKeyPrefix = exports.REDIS_CONNECTION_RETRY_DELAY_MS = exports.REDIS_CONNECTION_RETRY_ATTEMPTS = exports.REDIS_CONNECT_TIMEOUT = exports.SHARED_REDIS_PRIVATE_IP = exports.REDIS_PRIVATE_IP = exports.CRON_PORT = exports.API_URL = exports.API_ENDPOINT = exports.API_PORT = exports.API_HOST = exports.AUTH_JWT_EXPIRES_IN_TRAVEL_AGENT = exports.AUTH_REFRESH_JWT_EXPIRES_IN_SITE_BOOKING = exports.AUTH_JWT_EXPIRES_IN_SITE_BOOKING = exports.AUTH_REFRESH_JWT_EXPIRES_IN_SITE = exports.AUTH_JWT_EXPIRES_IN_SITE = exports.AUTH_REFRESH_JWT_EXPIRES_IN_CUSTOMER_APP = exports.AUTH_JWT_EXPIRES_IN_CUSTOMER_APP = exports.AUTH_REFRESH_JWT_EXPIRES_IN_DRIVERAPP = exports.AUTH_JWT_EXPIRES_IN_DRIVER_APP = exports.AUTH_JWT_SECRET_PATH = exports.AUTH_REFRESH_JWT_REFRESH_RATE_DENOMINATOR = exports.AUTH_JWT_REFRESH_RATE_DENOMINATOR = exports.AUTH_JWT_ISSUER = exports.AUTH_MANAGEMENT_JWT_SECRET = exports.AUTH_JWT_SECRET = exports.AUTH_JWT_EXPIRES_IN = exports.AUTH_JWT_AUDIENCE = exports.AUTH_JWT_ALGORITHM = exports.AUTH_REFRESH_JWT_EXPIRES_IN = exports.WEBSITE_APPLE_BUNDLE_ID = exports.CUSTOMER_APP_APPLE_BUNDLE_ID = exports.APPLE_MAPS_TOKEN = exports.APPLE_ID_URL = exports.APPLE_TOKEN_URL = exports.APPLE_TEAM_ID = exports.APPLE_KEY_ID = exports.APPLE_SECRET_PRIVATE_KEY = exports.APPLE_CLIENT_SECRET = exports.APPLE_BUNDLE_ID = exports.AUTH_LOGIN_LOCAL = exports.AUTH_LOGIN_FB = void 0;
exports.ALLOWED_DOCUMENT_EXTENSIONS = exports.ALLOWED_VIDEO_MIME_TYPES = exports.ALLOWED_FILE_FORMATS = exports.API_SERVER_MAX_LISTENERS = exports.API_TRIP_CHANGE_URGENT_NOTIFICATION_THRESHOLD_HOURS = exports.API_TRIP_CHANGE_EMAIL_DELAY = exports.GROOVE_API_TOKEN = exports.API_DOWNLOAD_ORDER_ICAL_URL = exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_CSV_URL = exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_XLS_URL = exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_FINANCE_CSV_ENDPOINT = exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_XLS_ENDPOINT = exports.API_DOWNLOAD_ORDER_ICAL_ENDPOINT = exports.API_DOWNLOAD_INVOICE_URL = exports.API_DOWNLOAD_INVOICE_ENDPOINT = exports.API_DOWNLOAD_S3_EXPORT_URL = exports.API_DOWNLOAD_S3_EXPORT_ENDPOINT = exports.API_ASSIGNATION_CSV_EXPORT_URL = exports.API_ASSIGNATION_CSV_EXPORT_ENDPOINT = exports.API_GROOVE_USER_PROFILE_PARTNERS_TO_EXCLUDE = exports.API_GROOVE_USER_PROFILE_URL = exports.API_GROOVE_USER_PROFILE_ENDPOINT = exports.API_UPLOAD_BILLING_INFO_DOCUMENT_URL = exports.API_UPLOAD_BILLING_INFO_DOCUMENT_ENDPOINT = exports.API_ORDER_PDF_URL = exports.API_ORDER_PDF_ENDPOINT = exports.API_UPLOAD_LOCATION_IMAGES_URL = exports.API_UPLOAD_LOCATION_IMAGES_ENDPOINT = exports.API_OPEN_VEHICLE_IMAGE_URL = exports.API_OPEN_VEHICLE_IMAGE_ENDPOINT = exports.API_REPLACE_VEHICLE_IMAGE_URL = exports.API_REPLACE_VEHICLE_IMAGE_ENDPOINT = exports.API_UPLOAD_VEHICLE_IMAGE_URL = exports.API_UPLOAD_VEHICLE_IMAGE_ENDPOINT = exports.API_OPEN_VEHICLE_DOCUMENT_URL = exports.API_OPEN_VEHICLE_DOCUMENT_ENDPOINT = exports.API_UPLOAD_VEHICLE_DOCUMENT_URL = exports.API_UPLOAD_VEHICLE_DOCUMENT_ENDPOINT = exports.API_OPEN_DRIVERS_COMPANY_DOCUMENT_URL = exports.API_OPEN_DRIVERS_COMPANY_DOCUMENT_ENDPOINT = exports.API_UPLOAD_DRIVERS_COMPANY_DOCUMENT_URL = exports.API_UPLOAD_DRIVERS_COMPANY_DOCUMENT_ENDPOINT = exports.API_OPEN_DRIVER_DOCUMENT_URL = exports.API_OPEN_DRIVER_DOCUMENT_ENDPOINT = exports.API_UPLOAD_DRIVER_SELFIE_VIDEO_URL = exports.API_UPLOAD_DRIVER_SELFIE_VIDEO_ENDPOINT = exports.API_UPLOAD_DRIVER_DOCUMENT_URL = exports.API_UPLOAD_DRIVER_DOCUMENT_ENDPOINT = exports.API_OPEN_PROFILE_IMAGE_URL = exports.API_OPEN_PROFILE_IMAGE_ENDPOINT = void 0;
exports.STRIPE_PAYOUT_NEXT_BATCH_DELAY = exports.STRIPE_PAYOUT_BATCH_SIZE = exports.STRIPE_CALLBACK_PORT = exports.STRIPE_CALLBACK_URL = exports.STRIPE_API_KEY = exports.CHECKOUT_NEW_PLATFORM_API_KEY = exports.CHECKOUT_NEW_PLATFORM_PUBLIC_KEY = exports.CHECKOUT_PUBLIC_API_KEY = exports.CHECKOUT_NEXT_BATCH_DELAY = exports.CHECKOUT_BATCH_SIZE = exports.CHECKOUT_CALLBACK_PORT = exports.CHECKOUT_CALLBACK_URL = exports.CHECKOUT_API_URL = exports.CHECKOUT_API_PROCESSING_CHANNEL_ID = exports.CHECKOUT_API_KEY = exports.HYPERWALLET_PROGRAM_TOKEN_CITA_PAYOUTS = exports.HYPERWALLET_ACCOUNT_ID_CITA_PAYOUTS = exports.HYPERWALLET_API_BALANCES_ACCOUNT_TOKEN = exports.HYPERWALLET_API_BALANCES_PROGRAM_TOKEN = exports.HYPERWALLET_API_PAYMENTS_PROGRAM_TOKEN = exports.HYPERWALLET_API_USERS_PROGRAM_TOKEN = exports.HYPERWALLET_API_PASSWORD = exports.HYPERWALLET_API_EMAIL = exports.HYPERWALLET_API_URL = exports.MANGOPAY_USD_PAYOUT_WALLET_ID = exports.MANGOPAY_EUR_PAYOUT_WALLET_ID = exports.MANGOPAY_DEBUG_MODE = exports.MANGOPAY_DEFAULT_DUMMY_ID = exports.MANGOPAY_WALLET_LIMIT = exports.MANGOPAY_CREDIT_WALLET_ID = exports.MANGOPAY_CREDIT_USER_ID = exports.MANGOPAY_CALLBACK_PORT = exports.MANGOPAY_CALLBACK_ENDPOINT = exports.MANGOPAY_CLIENT_PASSWORD = exports.MANGOPAY_CLIENT_ID = exports.MANGOPAY_BASE_URL = exports.CDN_BASE_URL = exports.REACT_ROOT_ELEMENT_ID = exports.VEHICLE_MAX_IMAGES_COUNT = exports.VEHICLE_DOCUMENTS_SUBFOLDER = exports.VEHICLE_IMAGES_SUBFOLDER = exports.PROFILE_IMAGES_SUBFOLDER = exports.FILES_FOLDER = exports.MAX_SELFIE_VIDEO_UPLOAD_SIZE_IN_B = exports.MAX_SELFIE_VIDEO_UPLOAD_SIZE_MB = exports.MAX_FILE_UPLOAD_SIZE_IN_B = exports.MAX_FILE_UPLOAD_SIZE_MB = exports.ALLOWED_IMPORT_FILE_FORMATS = exports.FILE_EXTENSIONS_TO_MIME_TYPES_MAP = exports.ALLOWED_VIDEO_EXTENSIONS = void 0;
exports.EUROPE_COUNTRIES_ISO_CODES = exports.EUROPEAN_UNION_COUNTRIES_ISO_CODES = exports.GCLID_COOKIE_NAME = exports.managementAuthCookies = exports.siteAuthCookies = exports.cookies = exports.LOGGER_LEVEL = exports.INVOICES_CSV_EXPORT_ENDPOINT = exports.APPLE_MAPS_SNAPSHOT_ROUTE_DIRECTIONS_ENDPOINT = exports.GOOGLE_DEFAULT_LANGUAGE = exports.GOOGLE_MAPS_API_KEY = exports.GOOGLE_MAPS_API_URL = exports.S3_AWS_REGION = exports.APP_AWS_REGION = exports.S3_VERSIONED_CONTENT_RESOURCES_BUCKET = exports.LOCAL_S3_REPORTS_SECRET_KEY = exports.LOCAL_S3_REPORTS_ACCESS_KEY = exports.S3_REPORTS_BUCKET_OBJECT_PREFIX = exports.S3_REPORTS_BUCKET_NAME = exports.S3_SETTLEMENTS_SECRET_KEY = exports.S3_SETTLEMENTS_ACCESS_KEY = exports.S3_SETTLEMENTS_BUCKET = exports.SKIP_SITEMAPS_GENERATION = exports.S3_FILES_AWS_REGION = exports.MAIN_S3_SECRET_KEY = exports.MAIN_S3_ACCESS_KEY = exports.S3_PUBLIC_STATIC_RESOURCES_BUCKET = exports.S3_SECRET_KEY = exports.S3_ACCESS_KEY = exports.S3_FILES_BUCKET = exports.TRAVEL_AGENT_FIRST_ORDER_DISCOUNT = exports.TRAVEL_AGENT_LOGIN_PATH = exports.TRAVEL_AGENT_REGISTER_PATH = exports.TRAVEL_AGENT_PATH = exports.DAYTRIP_SLACK_BOT_TOKEN = exports.DAYTRIP_SLACK_APP_TOKEN = exports.MONGODB_HEAVY_QUERY_READ_PREFERENCE = exports.MONGODB_HEAVY_QUERY_ALLOW_DISK_USE = exports.MONGODB_HEAVY_QUERY_TIMEOUT = exports.MONGODB_CONNECTION_STRING = exports.HEATMAP_API_TOKEN = exports.API_HEATMAP_ENDPOINT = exports.RESTPACK_API_URL = exports.RESTPACK_API_TOKEN = exports.ADWORDS_DEVELOPER_TOKEN = exports.ADWORDS_CUSTOMER_ID = exports.ADWORDS_REFRESH_TOKEN = exports.ADWORDS_SECRET = exports.ADWORDS_CLIENT_ID = exports.STRIPE_API_VERSION = void 0;
exports.SENTRY_DSN = exports.SENTRY_ENABLED = exports.DAYTRIP_MANAGEMENT_SENTRY_DSN = exports.FEATURE_TERMS_AND_CONDITIONS = exports.FEATURE_RICH_TEXT_SUPPORT = exports.FEATURE_DRIVER_APP_NEW_DESIGN_GLOBALLY_DISABLED = exports.FEATURE_CUSTOMER_TRIP_TRACKING = exports.FEATURE_EXPOSE_JWT_SIGN_RPC_METHODS = exports.FEATURE_FORCE_SECURE_MODE_FOR_EUROPE_COUNTRIES = exports.FEATURE_ASSIGNATION_OFFERS_AUTOMATION = exports.FEATURE_NEW_COOPERATION_AGREEMENT = exports.ONESIGNAL_CUSTOMER_APP_REST_API_KEY = exports.ONESIGNAL_CUSTOMER_APP_APP_ID = exports.ONESIGNAL_REST_API_KEY = exports.ONESIGNAL_APP_ID = exports.ONESIGNAL_REST_API_URL = exports.ONESIGNAL_ENABLED = exports.ASSIGNATION_PUBLIC_OFFERS_RADIUS_KM = exports.MANAGEMENT_GQL_PLAYGROUND_ENABLED = exports.MANAGEMENT_GQL_DEBUG_ENABLED = exports.EXCHANGERATESAPI_ACCESS_KEY = exports.POOL_AVAILABILITY_SERVICE_BACKOFF = exports.POOL_AVAILABILITY_SERVICE_RETRIES = exports.POOL_AVAILABILITY_SERVICE_TIMEOUT = exports.POOL_AVAILABILITY_SERVICE_ACCESSTOKEN = exports.POOL_AVAILABILITY_SERVICE_URL = exports.POOL_BOOKING_PAYMENT_AVAILABILITY_THRESHOLD_IN_HOURS = exports.PRIVATE_BOOKING_PAYMENT_AVAILABILITY_THRESHOLD_IN_HOURS = exports.CHANGES_CANNOT_BE_GUARANTEED_IN_HOURS = exports.LAST_MINUTE_ORDER_THRESHOLD_IN_HOURS = exports.ORDER_CHANGEABLE_THRESHOLD_IN_HOURS = exports.PENDING_ASSIGNATION_TIME_LIMIT_PASSED_TEXT = exports.PENDING_ASSIGNATION_TIME_LIMIT_IN_MS = exports.PENDING_ASSIGNATION_TIME_LIMIT_IN_HOURS = exports.DEFAULT_BIRTHDAY_AT = exports.GOOGLE_ANALYTICS_ACCOUNT = exports.TRAVEL_VOUCHER_TTL_MONTHS = exports.FEE_COEFICIENT_BASE = exports.TRAVEL_VOUCHER_DEFAULT_COUNTRY = exports.US_COUNTRY_ID = exports.NUMBER_MASKING_DEPARTURE_HOURS_AFTER = exports.NUMBER_MASKING_DEPARTURE_HOURS_BEFORE = exports.REDIS_ASSIGNATION_PINS_PREFIX = exports.HOME_TIMEZONE = exports.constant = exports.FB_DRIVERS_MESSENGER_USERNAME = exports.EMAIL_ATTEMPTS_THRESHOLD = exports.SUV_REPLACING_SEDAN_COUNTRIES_IDS = exports.SUV_REPLACING_SEDAN_COUNTRIES_ISO_CODES = exports.ASIA_COUNTRIES_ISO_CODES = void 0;
exports.EARLY_OFFERS_DISABLED = exports.ASSIGNATION_OFFER_AUTO_CANCELLATION_DISABLED = exports.ASSIGNATION_OFFER_REPOST_PRICE_COEFF = exports.MAX_AUTO_AVAILABILITY_CHECK_REPOST_LIMIT = exports.MAX_ASSIGNATION_OFFER_REPOST_LIMIT = exports.AUTO_POST_OFFERS_START_HOUR = exports.TRIP_DURATION_MAX_DISCOUNT_PERCENTAGE = exports.EARLY_ASSIGNATION_OFFERS_DISCOUNT_PERCENTAGE = exports.BASE_ASSIGNATION_OFFERS_DISCOUNT_PERCENTAGE = exports.PUBLIC_OFFERS_NOTIFICATION_BATCH_SIZE = exports.FORCE_COMBO_RECALCULATION_VALUE = exports.LOCKED_COMBO_MIN_SAVINGS_VALUE = exports.COMBO_MIN_SAVINGS_VALUE = exports.COMBO_MAX_CONNECTION_DISTANCE_KM_PERMISSIVE = exports.COMBO_MAX_CONNECTION_DISTANCE_KM_CONDITIONAL = exports.COMBO_ASSIGNATION_OFFERS_ENABLED = exports.ORDER_COMBOS_DISABLED = exports.MAX_DURATION_HOURS_BOOKING = exports.MIN_DURATION_HOURS_BOOKING = exports.HOURLY_DRIVER_LIMIT_KMS_PER_HOUR = exports.DEFAULT_FEE_COEFFICIENT = exports.APPLE_PAY_MANGOPAY_SESSION_CERTIFICATE = exports.APPLE_PAY_MANGOPAY_SESSION_CERTIFICATE_KEY = exports.APPLE_PAY_MANGOPAY_MERCHANT_ID = exports.APPLE_PAY_CHECKOUT_SESSION_CERTIFICATE = exports.APPLE_PAY_CHECKOUT_SESSION_CERTIFICATE_KEY = exports.APPLE_PAY_CHECKOUT_MERCHANT_ID = exports.READONLY_API_PARTNERS = exports.BLACKLISTED_API_PARTNERS = exports.PARTNERS_WITH_LITE_PRICING_OVERRIDE = exports.PARTNERS_WITH_FULL_LITE_SUPPORT = exports.PARTNER_API_FLEXIBLE_OFFERS_DISABLED = exports.RIDE_EMAILS_DISABLED = exports.NETHONE_BASIC_PASSWORD = exports.NETHONE_BASIC_USER_ID = exports.NETHONE_TRANSACTIONS_URL = exports.NETHONE_INQUIRIES_URL = exports.ASSIGNATION_OFFER_AUTO_CONFIRMATION_INTERVAL = exports.META_CAMPAIGN_FEED_SECRET_KEY = exports.ADWORDS_CAMPAIGN_FEED_SECRET_KEY = exports.DAYTRIP_KLAVIYO_FAMILY_CUSTOMERS_LIST_ID = exports.DAYTRIP_KLAVIYO_CUSTOMERS_LIST_ID = exports.DAYTRIP_KLAVIYO_API_URL = exports.DAYTRIP_KLAVIYO_API_REVISION = exports.DAYTRIP_KLAVIYO_API_KEY = exports.SENTRY_PAPI_SAMPLE_RATE = exports.SENTRY_MNG_GRAPHQL_SAMPLE_RATE = exports.SENTRY_GRAPHQL_SAMPLE_RATE = exports.SENTRY_RPC_SAMPLE_RATE = exports.SENTRY_ENVIRONMENT = void 0;
exports.DATALAYER_API_URL = exports.AMADEUS_API_BASE_URL = exports.AMADEUS_API_SECRET = exports.AMADEUS_API_KEY = exports.LEGACY_DRIVER_API_URL = exports.ORDER_DRAFT_EXPIRATION_TIME_IN = exports.CUSTOMER_APP_DESIRED_REQUIRED_VERSION = exports.CUSTOMER_APP_DESIRED_OPTIONAL_VERSION = exports.MANAGEMENT_BOT_USER_ID = exports.CUSTOMER_APP_GOOGLE_SIGN_IN_CLIENT_ID = exports.GOOGLE_SIGN_IN_CLIENT_ID = exports.VIES_URL = exports.TAX_ID_PRO_API_KEY = exports.TAX_ID_PRO_URL = exports.HIGH_PENALTY_LIMIT = exports.HIGH_COMPENSATION_LIMIT = exports.HIGH_SUBSIDY_LIMIT = exports.TRACKDESK_API_KEY = exports.TRACKDESK_REVENUE_ORIGIN_ID = exports.TRACKDESK_TENANT_ID = exports.DRIVER_TRIP_AUTO_CANCELLATION_HOURS_THRESHOLD = exports.RECALCULATE_INACTIVE_DRIVERS_SCORE = exports.LATEST_ASSIGNATIONS_FOR_RATING = exports.TRIP_OFFERS_ACCESS_TIME_MULTIPLIER = exports.POOL_ASSIGNATION_OFFERS_NOTIFICATIONS_ENABLED = exports.URGENT_OFFERS_REPOST_ENABLED = exports.AUTO_PUBLISH_OFFERS_CRON_TIME = exports.EARLY_OFFERS_DISABLE_COMBO_PREDICTION_COUNTRIES = void 0;
const constants_1 = require("@daytrip/constants");
var Application;
(function (Application) {
    Application["Management"] = "management";
    Application["Api"] = "api";
    Application["Cron"] = "cron";
})(Application || (exports.Application = Application = {}));
var Env;
(function (Env) {
    Env["DAYTRIP_SITE_BASE_URL"] = "DAYTRIP_SITE_BASE_URL";
    Env["DAYTRIP_JWT_SECRET_PATH"] = "DAYTRIP_JWT_SECRET_PATH";
    Env["DAYTRIP_TESTING_EMAIL"] = "DAYTRIP_TESTING_EMAIL";
    Env["DAYTRIP_API_MNG_GQL_URL"] = "DAYTRIP_API_MNG_GQL_URL";
    Env["DAYTRIP_API_HOST"] = "DAYTRIP_API_HOST";
    Env["DAYTRIP_API_PORT"] = "DAYTRIP_API_PORT";
    Env["DAYTRIP_API_ENDPOINT"] = "DAYTRIP_API_ENDPOINT";
    Env["DAYTRIP_FILES_FOLDER"] = "DAYTRIP_FILES_FOLDER";
    Env["DAYTRIP_PROFILE_IMAGES_SUBFOLDER"] = "DAYTRIP_PROFILE_IMAGES_SUBFOLDER";
    Env["DAYTRIP_VEHICLE_IMAGES_SUBFOLDER"] = "DAYTRIP_VEHICLE_IMAGES_SUBFOLDER";
    Env["DAYTRIP_VEHICLE_DOCUMENTS_SUBFOLDER"] = "DAYTRIP_VEHICLE_DOCUMENTS_SUBFOLDER";
    Env["DAYTRIP_MANGOPAY_URL"] = "DAYTRIP_MANGOPAY_URL";
    Env["DAYTRIP_MANGOPAY_ID"] = "DAYTRIP_MANGOPAY_ID";
    Env["DAYTRIP_MANGOPAY_PASSWORD"] = "DAYTRIP_MANGOPAY_PASSWORD";
    Env["DAYTRIP_MANGOPAY_CALLBACK_ENDPOINT"] = "DAYTRIP_MANGOPAY_CALLBACK_ENDPOINT";
    Env["DAYTRIP_MANGOPAY_CALLBACK_PORT"] = "DAYTRIP_MANGOPAY_CALLBACK_PORT";
    Env["DAYTRIP_SLACK_BOT_TOKEN"] = "DAYTRIP_SLACK_BOT_TOKEN";
    Env["DAYTRIP_POOL_AVAILABILITY_SERVICE_URL"] = "DAYTRIP_POOL_AVAILABILITY_SERVICE_URL";
    Env["DAYTRIP_POOL_AVAILABILITY_SERVICE_ACCESSTOKEN"] = "DAYTRIP_POOL_AVAILABILITY_SERVICE_ACCESSTOKEN";
    Env["DAYTRIP_POOL_AVAILABILITY_SERVICE_TIMEOUT"] = "DAYTRIP_POOL_AVAILABILITY_SERVICE_TIMEOUT";
    Env["DAYTRIP_POOL_AVAILABILITY_SERVICE_RETRIES"] = "DAYTRIP_POOL_AVAILABILITY_SERVICE_RETRIES";
    Env["DAYTRIP_POOL_AVAILABILITY_SERVICE_BACKOFF"] = "DAYTRIP_POOL_AVAILABILITY_SERVICE_BACKOFF";
    Env["DAYTRIP_MANGOPAY_WALLET_LIMIT"] = "DAYTRIP_MANGOPAY_WALLET_LIMIT";
    Env["GOOGLE_MAPS_API_URL"] = "GOOGLE_MAPS_API_URL";
    Env["GOOGLE_MAPS_API_KEY"] = "GOOGLE_MAPS_API_KEY";
    Env["APPLE_MAPS_API_KEY"] = "APPLE_MAPS_API_KEY";
    Env["GOOGLE_ANALYTICS_ACCOUNT"] = "GOOGLE_ANALYTICS_ACCOUNT";
    Env["DAYTRIP_MANAGEMENT_GQL_DEBUG_ENABLED"] = "MANAGEMENT_GQL_DEBUG_ENABLED";
    Env["DAYTRIP_MANAGEMENT_GQL_PLAYGROUND_ENABLED"] = "MANAGEMENT_GQL_PLAYGROUND_ENABLED";
    Env["DAYTRIP_MANAGEMENT_SENTRY_DSN"] = "DAYTRIP_MANAGEMENT_SENTRY_DSN";
})(Env || (exports.Env = Env = {}));
exports.ENVIRONMENT = global.BUILD_ENV;
exports.LOCAL_IP = process.env.DAYTRIP_LOCAL_IP;
exports.IS_PRODUCTION = exports.ENVIRONMENT === "production";
exports.IS_DEVELOPMENT = exports.ENVIRONMENT === "development";
exports.IS_DYNAMIC = exports.ENVIRONMENT === "dynamic-environment";
exports.IS_STAGING = exports.ENVIRONMENT === "staging";
exports.IS_TEST = exports.ENVIRONMENT === "test";
exports.IS_DYNAMIC_OR_TEST = exports.IS_DYNAMIC || exports.IS_TEST;
exports.IS_LOCAL = exports.IS_DEVELOPMENT ||
    exports.LOCAL_IP !== undefined ||
    process.env.DAYTRIP_IS_LOCAL === "true";
if (!exports.IS_PRODUCTION &&
    global.DEPLOYMENT_NODE &&
    !process.env.DAYTRIP_TESTING_EMAIL) {
    console.error("Testing email is not specified!");
}
exports.MAILGUN_DOMAIN = process.env.DAYTRIP_MAILGUN_DOMAIN;
exports.MAILGUN_API_KEY = process.env.DAYTRIP_MAILGUN_API_KEY;
exports.TESTING_EMAIL = process.env.DAYTRIP_TESTING_EMAIL;
exports.PAGINATION_DEFAULT_COUNT = 15;
function replaceLocalhostWithIp(address) {
    if (exports.LOCAL_IP !== undefined && address !== undefined) {
        return address.replace(/localhost/, exports.LOCAL_IP);
    }
    return address;
}
exports.COOKIE_PREFIX = exports.IS_PRODUCTION ? "" : `${exports.ENVIRONMENT}-`;
function determineManagementCookiePrefixFromEnvironment(environment) {
    switch (environment) {
        case "production":
            throw new Error("Production should not have a prefix.");
        default:
            return environment;
    }
}
exports.MANAGEMENT_COOKIE_PREFIX = exports.IS_PRODUCTION
    ? ""
    : `${determineManagementCookiePrefixFromEnvironment(exports.ENVIRONMENT)}-`;
exports.BASE_IMAGE_URL = "https://daytrip.imgix.net";
exports.SITE_BASE_URL = replaceLocalhostWithIp(process.env.DAYTRIP_SITE_BASE_URL);
exports.SITE_DOMAIN = (exports.SITE_BASE_URL && new URL(exports.SITE_BASE_URL).hostname) || undefined;
exports.WEBSITE_CONFIRM_PASSWORD_RESET_URL = `${exports.SITE_BASE_URL}/confirm-password-reset`;
const getWebsiteConfirmPasswordResetUrl = (token) => `${exports.WEBSITE_CONFIRM_PASSWORD_RESET_URL}?token=${token}`;
exports.getWebsiteConfirmPasswordResetUrl = getWebsiteConfirmPasswordResetUrl;
exports.WEBSITE_CUSTOMER_ORDERS = "customer/orders";
exports.TRAVEL_AGENT_PASSWORD_RESET_URL = `${exports.SITE_BASE_URL}/travel-agent/reset-password`;
const getTravelAgentPasswordResetUrl = (token) => `${exports.TRAVEL_AGENT_PASSWORD_RESET_URL}?token=${token}`;
exports.getTravelAgentPasswordResetUrl = getTravelAgentPasswordResetUrl;
exports.DAYTRIP_SITE_URL = `${exports.SITE_BASE_URL}/`;
exports.DAYTRIP_REFERRAL_LINK = `${exports.SITE_BASE_URL}/r/`;
exports.DRIVER_APP_SCHEMA = process.env.DAYTRIP_DRIVER_APP_SCHEMA;
exports.WHATSAPP_DRIVER_SUPPORT_CONTACT = process.env.DAYTRIP_WHATSAPP_DRIVER_SUPPORT_CONTACT;
exports.DAYTRIP_EMAIL = exports.IS_PRODUCTION
    ? "daytrip@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_AGENTS_EMAIL = exports.IS_PRODUCTION
    ? "agents@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_BOOKINGS_EMAIL = exports.IS_PRODUCTION
    ? "bookings@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_DRIVERS_EMAIL = exports.IS_PRODUCTION
    ? "drivers@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_CUSTOMERS_EMAIL = exports.IS_PRODUCTION
    ? "customers@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_FEEDBACK_EMAIL = exports.IS_PRODUCTION
    ? "feedback@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_DISCOVER_EMAIL = exports.IS_PRODUCTION
    ? "discovermore@daytrip.com"
    : process.env.DAYTRIP_SYSTEM_TEST_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_NOTIFICATION_EMAIL = process.env.DAYTRIP_NOTIFICATION_EMAIL ||
    "sandbox+notifications@mydaytrip.com";
exports.DAYTRIP_BILLING_EMAIL = exports.IS_PRODUCTION
    ? "billing@daytrip.com"
    : process.env.DAYTRIP_BILLING_EMAIL || "sandbox@mydaytrip.com";
exports.DAYTRIP_SYSTEM_STEPAN_VURM_EMAIL = process.env.DAYTRIP_STEPAN_VURM_EMAIL ||
    "sandbox+notifications@mydaytrip.com";
exports.DAYTRIP_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_EMAIL}>`;
exports.DAYTRIP_DRIVERS_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_DRIVERS_EMAIL}>`;
exports.DAYTRIP_AGENTS_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_AGENTS_EMAIL}>`;
exports.DAYTRIP_BOOKINGS_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_BOOKINGS_EMAIL}>`;
exports.DAYTRIP_CUSTOMERS_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_CUSTOMERS_EMAIL}>`;
exports.DAYTRIP_FEEDBACK_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_FEEDBACK_EMAIL}>`;
exports.DAYTRIP_NOTIFICATION_EMAIL_STRING = `Team Daytrip <${exports.DAYTRIP_NOTIFICATION_EMAIL}>`;
exports.DAYTRIP_NOTIFICATION_DISCOVER_STRING = `Team Daytrip <${exports.DAYTRIP_DISCOVER_EMAIL}>`;
let daytripFirstRideNotificationEmails;
if (process.env.DAYTRIP_FIRST_RIDE_NOTIFICATION_BCC_EMAILS) {
    try {
        daytripFirstRideNotificationEmails = JSON.parse(process.env.DAYTRIP_FIRST_RIDE_NOTIFICATION_BCC_EMAILS);
    }
    catch (err) {
        throw new Error("Invalid JSON array for process.env.DAYTRIP_FIRST_RIDE_NOTIFICATION_BCC_EMAILS");
    }
}
exports.FIRST_RIDE_NOTIFICATION_BCC_EMAILS = daytripFirstRideNotificationEmails;
exports.MANAGEMENT_URL = process.env.DAYTRIP_MANAGEMENT_URL;
exports.AUTH_BASE_URL = "http://localhost:8080";
exports.AUTH_LOGIN_FB = "/login/facebook";
exports.AUTH_LOGIN_LOCAL = "/login/local";
exports.APPLE_BUNDLE_ID = process.env.DAYTRIP_APPLE_BUNDLE_ID || "com.mydaytrip.Daytrip";
exports.APPLE_CLIENT_SECRET = process.env.DAYTRIP_APPLE_CLIENT_SECRET;
exports.APPLE_SECRET_PRIVATE_KEY = process.env.DAYTRIP_APPLE_SECRET_PRIVATE_KEY;
exports.APPLE_KEY_ID = process.env.DAYTRIP_APPLE_KEY_ID;
exports.APPLE_TEAM_ID = process.env.DAYTRIP_APPLE_TEAM_ID;
exports.APPLE_TOKEN_URL = process.env.DAYTRIP_APPLE_TOKEN_URL;
exports.APPLE_ID_URL = process.env.DAYTRIP_APPLE_ID_URL;
exports.APPLE_MAPS_TOKEN = process.env.DAYTRIP_APPLE_MAPS_TOKEN;
exports.CUSTOMER_APP_APPLE_BUNDLE_ID = process.env.DAYTRIP_CUSTOMER_APP_APPLE_BUNDLE_ID;
exports.WEBSITE_APPLE_BUNDLE_ID = process.env.DAYTRIP_WEBSITE_APPLE_BUNDLE_ID;
exports.AUTH_REFRESH_JWT_EXPIRES_IN = process.env.DAYTRIP_AUTH_REFRESH_JWT_EXPIRES_IN || "96h";
exports.AUTH_JWT_ALGORITHM = "HS256";
exports.AUTH_JWT_AUDIENCE = "mydaytrip.com";
exports.AUTH_JWT_EXPIRES_IN = process.env.DAYTRIP_AUTH_JWT_EXPIRES_IN || "25m";
exports.AUTH_JWT_SECRET = process.env.DAYTRIP_JWT_SECRET_VALUE;
exports.AUTH_MANAGEMENT_JWT_SECRET = process.env.DAYTRIP_MANAGEMENT_JWT_SECRET_VALUE;
exports.AUTH_JWT_ISSUER = "auth.mydaytrip.com";
exports.AUTH_JWT_REFRESH_RATE_DENOMINATOR = 5;
exports.AUTH_REFRESH_JWT_REFRESH_RATE_DENOMINATOR = 21;
exports.AUTH_JWT_SECRET_PATH = process.env.DAYTRIP_JWT_SECRET_PATH;
const DEFAULT_AUTH_JWT_EXPIRES_IN_DRIVER_APP = "1d";
exports.AUTH_JWT_EXPIRES_IN_DRIVER_APP = process.env.DAYTRIP_AUTH_JWT_EXPIRES_IN_DRIVER_APP ||
    DEFAULT_AUTH_JWT_EXPIRES_IN_DRIVER_APP;
const DEFAULT_AUTH_REFRESH_JWT_EXPIRES_IN_DRIVERAPP = "21d";
exports.AUTH_REFRESH_JWT_EXPIRES_IN_DRIVERAPP = process.env.DAYTRIP_AUTH_REFRESH_JWT_EXPIRES_IN_DRIVERAPP ||
    DEFAULT_AUTH_REFRESH_JWT_EXPIRES_IN_DRIVERAPP;
const DEFAULT_AUTH_JWT_EXPIRES_IN_CUSTOMER_APP = "1d";
exports.AUTH_JWT_EXPIRES_IN_CUSTOMER_APP = process.env.DAYTRIP_AUTH_JWT_EXPIRES_IN_CUSTOMER_APP ||
    DEFAULT_AUTH_JWT_EXPIRES_IN_CUSTOMER_APP;
const DEFAULT_AUTH_REFRESH_JWT_EXPIRES_IN_CUSTOMER_APP = "21d";
exports.AUTH_REFRESH_JWT_EXPIRES_IN_CUSTOMER_APP = process.env.DAYTRIP_AUTH_REFRESH_JWT_EXPIRES_IN_CUSTOMER_APP ||
    DEFAULT_AUTH_REFRESH_JWT_EXPIRES_IN_CUSTOMER_APP;
exports.AUTH_JWT_EXPIRES_IN_SITE = "25m";
exports.AUTH_REFRESH_JWT_EXPIRES_IN_SITE = "48h";
exports.AUTH_JWT_EXPIRES_IN_SITE_BOOKING = "1d";
exports.AUTH_REFRESH_JWT_EXPIRES_IN_SITE_BOOKING = "5d";
exports.AUTH_JWT_EXPIRES_IN_TRAVEL_AGENT = process.env.DAYTRIP_AUTH_JWT_EXPIRES_IN_TRAVEL_AGENT || "1d";
exports.API_HOST = replaceLocalhostWithIp(process.env.DAYTRIP_API_HOST);
exports.API_PORT = process.env.DAYTRIP_API_PORT;
exports.API_ENDPOINT = process.env.DAYTRIP_API_ENDPOINT;
exports.API_URL = `${exports.API_HOST}${exports.IS_LOCAL ? `:${exports.API_PORT}` : ""}`;
exports.CRON_PORT = process.env.DAYTRIP_CRON_PORT || 80;
exports.REDIS_PRIVATE_IP = process.env.DAYTRIP_REDIS_PRIVATE_IP;
exports.SHARED_REDIS_PRIVATE_IP = process.env.DAYTRIP_SHARED_REDIS_PRIVATE_IP || exports.REDIS_PRIVATE_IP;
exports.REDIS_CONNECT_TIMEOUT = 10 * 1000;
exports.REDIS_CONNECTION_RETRY_ATTEMPTS = Number(process.env.DAYTRIP_REDIS_CONNECTION_RETRY_ATTEMPTS || 10);
exports.REDIS_CONNECTION_RETRY_DELAY_MS = Number(process.env.DAYTRIP_REDIS_CONNECTION_RETRY_DELAY_MS || 5000);
const shouldPrefixKeys = () => !["production", "staging", "integration-tests", "development"].includes(process.env.NODE_ENV ?? "");
const getRedisKeyPrefix = () => {
    if (!shouldPrefixKeys()) {
        return;
    }
    return process.env.API_VERSION;
};
exports.getRedisKeyPrefix = getRedisKeyPrefix;
exports.API_RESET_PASSWORD_ENDPOINT = "/resetPassword";
exports.API_CUSTOMER_VERIFY_EMAIL = "/verifyCustomerEmail";
exports.API_CUSTOMER_VERIFY_EMAIL_REDIRECT_URL = process.env.DAYTRIP_API_CUSTOMER_VERIFY_EMAIL_REDIRECT_URL ??
    "/customer/orders";
exports.API_SIGN_IN_TO_CI_AS_CUSTOMER = "/signInToCIAsCustomer";
exports.API_SIGN_IN_TO_CI_AS_CUSTOMER_URL = `${exports.API_URL}${exports.API_SIGN_IN_TO_CI_AS_CUSTOMER}`;
exports.API_AUTH_MAGIC_LINK_ENDPOINT = "/account/link";
exports.API_UPLOAD_PROFILE_PHOTO_ENDPOINT = "/uploadProfileImage";
exports.API_UPLOAD_PROFILE_PHOTO_URL = `${exports.API_URL}${exports.API_UPLOAD_PROFILE_PHOTO_ENDPOINT}`;
exports.API_OPEN_PROFILE_IMAGE_ENDPOINT = "/openProfileImage";
exports.API_OPEN_PROFILE_IMAGE_URL = `${exports.API_URL}${exports.API_OPEN_PROFILE_IMAGE_ENDPOINT}`;
exports.API_UPLOAD_DRIVER_DOCUMENT_ENDPOINT = "/uploadDriverDocument";
exports.API_UPLOAD_DRIVER_DOCUMENT_URL = `${exports.API_URL}${exports.API_UPLOAD_DRIVER_DOCUMENT_ENDPOINT}`;
exports.API_UPLOAD_DRIVER_SELFIE_VIDEO_ENDPOINT = "/uploadDriverSelfieVideo";
exports.API_UPLOAD_DRIVER_SELFIE_VIDEO_URL = `${exports.API_URL}${exports.API_UPLOAD_DRIVER_SELFIE_VIDEO_ENDPOINT}`;
exports.API_OPEN_DRIVER_DOCUMENT_ENDPOINT = "/openDriverDocument";
exports.API_OPEN_DRIVER_DOCUMENT_URL = `${exports.API_URL}${exports.API_OPEN_DRIVER_DOCUMENT_ENDPOINT}`;
exports.API_UPLOAD_DRIVERS_COMPANY_DOCUMENT_ENDPOINT = "/uploadDriversCompanyDocument";
exports.API_UPLOAD_DRIVERS_COMPANY_DOCUMENT_URL = `${exports.API_URL}${exports.API_UPLOAD_DRIVERS_COMPANY_DOCUMENT_ENDPOINT}`;
exports.API_OPEN_DRIVERS_COMPANY_DOCUMENT_ENDPOINT = "/openDriversCompanyDocument";
exports.API_OPEN_DRIVERS_COMPANY_DOCUMENT_URL = `${exports.API_URL}${exports.API_OPEN_DRIVERS_COMPANY_DOCUMENT_ENDPOINT}`;
exports.API_UPLOAD_VEHICLE_DOCUMENT_ENDPOINT = "/uploadVehicleDocument";
exports.API_UPLOAD_VEHICLE_DOCUMENT_URL = `${exports.API_URL}${exports.API_UPLOAD_VEHICLE_DOCUMENT_ENDPOINT}`;
exports.API_OPEN_VEHICLE_DOCUMENT_ENDPOINT = "/openVehicleDocument";
exports.API_OPEN_VEHICLE_DOCUMENT_URL = `${exports.API_URL}${exports.API_OPEN_VEHICLE_DOCUMENT_ENDPOINT}`;
exports.API_UPLOAD_VEHICLE_IMAGE_ENDPOINT = "/uploadVehicleImages";
exports.API_UPLOAD_VEHICLE_IMAGE_URL = `${exports.API_URL}${exports.API_UPLOAD_VEHICLE_IMAGE_ENDPOINT}`;
exports.API_REPLACE_VEHICLE_IMAGE_ENDPOINT = "/replaceVehicleImages";
exports.API_REPLACE_VEHICLE_IMAGE_URL = `${exports.API_URL}${exports.API_REPLACE_VEHICLE_IMAGE_ENDPOINT}`;
exports.API_OPEN_VEHICLE_IMAGE_ENDPOINT = "/files/openVehicleImage";
exports.API_OPEN_VEHICLE_IMAGE_URL = `${exports.IS_LOCAL ? exports.API_URL : ""}${exports.API_OPEN_VEHICLE_IMAGE_ENDPOINT}`;
exports.API_UPLOAD_LOCATION_IMAGES_ENDPOINT = "/uploadLocationImages";
exports.API_UPLOAD_LOCATION_IMAGES_URL = `${exports.API_URL}${exports.API_UPLOAD_LOCATION_IMAGES_ENDPOINT}`;
exports.API_ORDER_PDF_ENDPOINT = "/voucher";
exports.API_ORDER_PDF_URL = `${exports.API_URL}${exports.API_ORDER_PDF_ENDPOINT}`;
exports.API_UPLOAD_BILLING_INFO_DOCUMENT_ENDPOINT = "/uploadBillingInfoDocument";
exports.API_UPLOAD_BILLING_INFO_DOCUMENT_URL = `${exports.API_URL}${exports.API_UPLOAD_BILLING_INFO_DOCUMENT_ENDPOINT}`;
exports.API_GROOVE_USER_PROFILE_ENDPOINT = "/grooveCustomProfile";
exports.API_GROOVE_USER_PROFILE_URL = `${exports.API_URL}${exports.API_GROOVE_USER_PROFILE_ENDPOINT}`;
exports.API_GROOVE_USER_PROFILE_PARTNERS_TO_EXCLUDE = process.env.DAYTRIP_GROOVE_USER_PROFILE_PARTNERS_TO_EXCLUDE ||
    "bookings@airportstaxitransfers.com,transfers@emergingtravel.com,fake@emergingtravel.com";
exports.API_ASSIGNATION_CSV_EXPORT_ENDPOINT = "/assignationCSVExport";
exports.API_ASSIGNATION_CSV_EXPORT_URL = `${exports.API_URL}${exports.API_ASSIGNATION_CSV_EXPORT_ENDPOINT}`;
exports.API_DOWNLOAD_S3_EXPORT_ENDPOINT = "/downloadS3Export";
exports.API_DOWNLOAD_S3_EXPORT_URL = `${exports.API_URL}${exports.API_DOWNLOAD_S3_EXPORT_ENDPOINT}`;
exports.API_DOWNLOAD_INVOICE_ENDPOINT = "/invoice";
exports.API_DOWNLOAD_INVOICE_URL = `${exports.API_URL}${exports.API_DOWNLOAD_INVOICE_ENDPOINT}`;
exports.API_DOWNLOAD_ORDER_ICAL_ENDPOINT = "/downloadOrderIcal";
exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_XLS_ENDPOINT = "/downloadCommissionPayoutRequestsXlsFile";
exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_FINANCE_CSV_ENDPOINT = "/downloadCommissionPayoutRequestsFinanceCsvFile";
exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_XLS_URL = `${exports.API_URL}${exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_XLS_ENDPOINT}`;
exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_CSV_URL = `${exports.API_URL}${exports.API_DOWNLOAD_COMMISSION_PAYOUT_REQUEST_FINANCE_CSV_ENDPOINT}`;
exports.API_DOWNLOAD_ORDER_ICAL_URL = `${exports.API_URL}${exports.API_DOWNLOAD_ORDER_ICAL_ENDPOINT}`;
exports.GROOVE_API_TOKEN = process.env.DAYTRIP_GROOVE_API_TOKEN;
exports.API_TRIP_CHANGE_EMAIL_DELAY = 10 * 60 * 1000;
exports.API_TRIP_CHANGE_URGENT_NOTIFICATION_THRESHOLD_HOURS = Number(process.env.DAYTRIP_API_TRIP_CHANGE_URGENT_NOTIFICATION_THRESHOLD_HOURS) || 3;
exports.API_SERVER_MAX_LISTENERS = 0;
exports.ALLOWED_FILE_FORMATS = [
    "image/jpeg",
    "image/png",
    "application/pdf",
];
exports.ALLOWED_VIDEO_MIME_TYPES = [
    "video/mp4",
    "video/quicktime",
    "video/webm",
];
exports.ALLOWED_DOCUMENT_EXTENSIONS = [".pdf", ".png", ".jpeg", ".jpg"];
exports.ALLOWED_VIDEO_EXTENSIONS = [".mp4", ".mov", ".webm"];
exports.FILE_EXTENSIONS_TO_MIME_TYPES_MAP = {
    ".jpg": "image/jpeg",
    ".jpeg": "image/jpeg",
    ".png": "image/png",
    ".pdf": "application/pdf",
    ".mp4": "video/mp4",
    ".mov": "video/quicktime",
    ".webm": "video/webm",
};
exports.ALLOWED_IMPORT_FILE_FORMATS = [
    "text/csv",
    "application/vnd.ms-excel",
    "text/json",
];
exports.MAX_FILE_UPLOAD_SIZE_MB = 5;
exports.MAX_FILE_UPLOAD_SIZE_IN_B = exports.MAX_FILE_UPLOAD_SIZE_MB * 1024 * 1024;
exports.MAX_SELFIE_VIDEO_UPLOAD_SIZE_MB = 200;
exports.MAX_SELFIE_VIDEO_UPLOAD_SIZE_IN_B = exports.MAX_SELFIE_VIDEO_UPLOAD_SIZE_MB * 1024 * 1024;
exports.FILES_FOLDER = process.env.DAYTRIP_FILES_FOLDER;
exports.PROFILE_IMAGES_SUBFOLDER = process.env.DAYTRIP_PROFILE_IMAGES_SUBFOLDER;
exports.VEHICLE_IMAGES_SUBFOLDER = process.env.DAYTRIP_VEHICLE_IMAGES_SUBFOLDER;
exports.VEHICLE_DOCUMENTS_SUBFOLDER = process.env.DAYTRIP_VEHICLE_DOCUMENTS_SUBFOLDER;
exports.VEHICLE_MAX_IMAGES_COUNT = 4;
exports.REACT_ROOT_ELEMENT_ID = "app";
exports.CDN_BASE_URL = "https://1160549601.rsc.cdn77.org";
exports.MANGOPAY_BASE_URL = process.env.DAYTRIP_MANGOPAY_URL;
exports.MANGOPAY_CLIENT_ID = process.env.DAYTRIP_MANGOPAY_ID;
exports.MANGOPAY_CLIENT_PASSWORD = process.env.DAYTRIP_MANGOPAY_PASSWORD;
exports.MANGOPAY_CALLBACK_ENDPOINT = process.env.DAYTRIP_MANGOPAY_CALLBACK_ENDPOINT;
exports.MANGOPAY_CALLBACK_PORT = process.env.DAYTRIP_MANGOPAY_CALLBACK_PORT;
exports.MANGOPAY_CREDIT_USER_ID = process.env.DAYTRIP_MANGOPAY_CREDIT_USER_ID;
exports.MANGOPAY_CREDIT_WALLET_ID = process.env.DAYTRIP_MANGOPAY_CREDIT_WALLET_ID;
exports.MANGOPAY_WALLET_LIMIT = Number(process.env.DAYTRIP_MANGOPAY_WALLET_LIMIT) || 2500;
exports.MANGOPAY_DEFAULT_DUMMY_ID = "123456789";
exports.MANGOPAY_DEBUG_MODE = !(process.env.DAYTRIP_MANGOPAY_DEBUG_MODE === "false");
exports.MANGOPAY_EUR_PAYOUT_WALLET_ID = process.env.DAYTRIP_MANGOPAY_EUR_PAYOUT_WALLET_ID || "193126625";
exports.MANGOPAY_USD_PAYOUT_WALLET_ID = process.env.DAYTRIP_MANGOPAY_USD_PAYOUT_WALLET_ID || "193126691";
exports.HYPERWALLET_API_URL = process.env.DAYTRIP_HYPERWALLET_API_URL;
exports.HYPERWALLET_API_EMAIL = process.env.DAYTRIP_HYPERWALLET_API_EMAIL;
exports.HYPERWALLET_API_PASSWORD = process.env.DAYTRIP_HYPERWALLET_API_PASSWORD;
exports.HYPERWALLET_API_USERS_PROGRAM_TOKEN = process.env.DAYTRIP_HYPERWALLET_API_USERS_PROGRAM_TOKEN;
exports.HYPERWALLET_API_PAYMENTS_PROGRAM_TOKEN = process.env.DAYTRIP_HYPERWALLET_API_PAYMENTS_PROGRAM_TOKEN;
exports.HYPERWALLET_API_BALANCES_PROGRAM_TOKEN = process.env.DAYTRIP_HYPERWALLET_API_BALANCES_PROGRAM_TOKEN;
exports.HYPERWALLET_API_BALANCES_ACCOUNT_TOKEN = process.env.DAYTRIP_HYPERWALLET_API_BALANCES_ACCOUNT_TOKEN;
exports.HYPERWALLET_ACCOUNT_ID_CITA_PAYOUTS = process.env.DAYTRIP_HYPERWALLET_ACCOUNT_ID_CITA_PAYOUTS;
exports.HYPERWALLET_PROGRAM_TOKEN_CITA_PAYOUTS = process.env.DAYTRIP_HYPERWALLET_PROGRAM_TOKEN_CITA_PAYOUTS;
exports.CHECKOUT_API_KEY = process.env.DAYTRIP_CHECKOUT_API_KEY;
exports.CHECKOUT_API_PROCESSING_CHANNEL_ID = process.env.DAYTRIP_CHECKOUT_API_PROCESSING_CHANNEL_ID;
exports.CHECKOUT_API_URL = process.env.DAYTRIP_CHECKOUT_API_URL;
exports.CHECKOUT_CALLBACK_URL = process.env.DAYTRIP_CHECKOUT_CALLBACK_URL;
exports.CHECKOUT_CALLBACK_PORT = process.env.DAYTRIP_CHECKOUT_CALLBACK_PORT;
exports.CHECKOUT_BATCH_SIZE = 50;
exports.CHECKOUT_NEXT_BATCH_DELAY = 1500;
exports.CHECKOUT_PUBLIC_API_KEY = process.env.DAYTRIP_CHECKOUT_PUBLIC_API_KEY || "";
exports.CHECKOUT_NEW_PLATFORM_PUBLIC_KEY = process.env.DAYTRIP_CHECKOUT_NEW_PLATFORM_PUBLIC_KEY;
exports.CHECKOUT_NEW_PLATFORM_API_KEY = process.env.DAYTRIP_CHECKOUT_NEW_PLATFORM_API_KEY;
exports.STRIPE_API_KEY = process.env.DAYTRIP_STRIPE_API_KEY || "";
exports.STRIPE_CALLBACK_URL = process.env.DAYTRIP_STRIPE_CALLBACK_URL;
exports.STRIPE_CALLBACK_PORT = process.env.DAYTRIP_STRIPE_CALLBACK_PORT;
exports.STRIPE_PAYOUT_BATCH_SIZE = Number(process.env.DAYTRIP_STRIPE_PAYOUT_BATCH_SIZE) || 18;
exports.STRIPE_PAYOUT_NEXT_BATCH_DELAY = Number(process.env.DAYTRIP_STRIPE_PAYOUT_NEXT_BATCH_DELAY) || 2000;
exports.STRIPE_API_VERSION = "2022-11-15";
exports.ADWORDS_CLIENT_ID = process.env.DAYTRIP_ADWORDS_CLIENT_ID;
exports.ADWORDS_SECRET = process.env.DAYTRIP_ADWORDS_SECRET;
exports.ADWORDS_REFRESH_TOKEN = process.env.DAYTRIP_ADWORDS_REFRESH_TOKEN;
exports.ADWORDS_CUSTOMER_ID = process.env.DAYTRIP_ADWORDS_CUSTOMER_ID;
exports.ADWORDS_DEVELOPER_TOKEN = process.env.DAYTRIP_ADWORDS_DEVELOPER_TOKEN;
exports.RESTPACK_API_TOKEN = process.env.DAYTRIP_RESTPACK_API_TOKEN;
exports.RESTPACK_API_URL = process.env.DAYTRIP_RESTPACK_API_URL;
exports.API_HEATMAP_ENDPOINT = "/heatmap-data";
exports.HEATMAP_API_TOKEN = process.env.DAYTRIP_HEATMAP_API_TOKEN;
exports.MONGODB_CONNECTION_STRING = process.env.DAYTRIP_MONGODB_CONNECTION_STRING;
exports.MONGODB_HEAVY_QUERY_TIMEOUT = process.env
    .DAYTRIP_MONGODB_HEAVY_QUERY_TIMEOUT
    ? parseInt(process.env.DAYTRIP_MONGODB_HEAVY_QUERY_TIMEOUT)
    : 40000;
exports.MONGODB_HEAVY_QUERY_ALLOW_DISK_USE = (process.env.DAYTRIP_MONGODB_HEAVY_QUERY_ALLOW_DISK_USE?.toLowerCase() ===
    "true" || true);
exports.MONGODB_HEAVY_QUERY_READ_PREFERENCE = (process.env
    .DAYTRIP_MONGODB_HEAVY_QUERY_READ_PREFERENCE || "secondary");
exports.DAYTRIP_SLACK_APP_TOKEN = process.env.DAYTRIP_SLACK_APP_TOKEN;
exports.DAYTRIP_SLACK_BOT_TOKEN = process.env.DAYTRIP_SLACK_BOT_TOKEN;
exports.TRAVEL_AGENT_PATH = `${exports.DAYTRIP_SITE_URL}travel-agent`;
exports.TRAVEL_AGENT_REGISTER_PATH = `${exports.TRAVEL_AGENT_PATH}/register`;
exports.TRAVEL_AGENT_LOGIN_PATH = `${exports.TRAVEL_AGENT_PATH}/login`;
exports.TRAVEL_AGENT_FIRST_ORDER_DISCOUNT = parseFloat(process.env.DAYTRIP_TRAVEL_AGENT_FIRST_ORDER_DISCOUNT ?? "0");
exports.S3_FILES_BUCKET = process.env.DAYTRIP_S3_FILES_BUCKET;
exports.S3_ACCESS_KEY = process.env.DAYTRIP_S3_ACCESS_KEY;
exports.S3_SECRET_KEY = process.env.DAYTRIP_S3_SECRET_KEY;
exports.S3_PUBLIC_STATIC_RESOURCES_BUCKET = process.env.DAYTRIP_S3_STATIC_RESOURCES_BUCKET;
exports.MAIN_S3_ACCESS_KEY = process.env.DAYTRIP_MAIN_S3_ACCESS_KEY;
exports.MAIN_S3_SECRET_KEY = process.env.DAYTRIP_MAIN_S3_SECRET_KEY;
exports.S3_FILES_AWS_REGION = "us-east-2";
exports.SKIP_SITEMAPS_GENERATION = process.env.DAYTRIP_SKIP_SITEMAPS_GENERATION === "true";
exports.S3_SETTLEMENTS_BUCKET = process.env.DAYTRIP_S3_SETTLEMENTS_BUCKET;
exports.S3_SETTLEMENTS_ACCESS_KEY = process.env.DAYTRIP_S3_SETTLEMENTS_ACCESS_KEY;
exports.S3_SETTLEMENTS_SECRET_KEY = process.env.DAYTRIP_S3_SETTLEMENTS_SECRET_KEY;
exports.S3_REPORTS_BUCKET_NAME = process.env.DAYTRIP_S3_REPORTS_BUCKET_NAME;
exports.S3_REPORTS_BUCKET_OBJECT_PREFIX = process.env.DAYTRIP_S3_REPORTS_OBJECT_PREFIX;
exports.LOCAL_S3_REPORTS_ACCESS_KEY = process.env.DAYTRIP_LOCAL_S3_REPORTS_ACCESS_KEY;
exports.LOCAL_S3_REPORTS_SECRET_KEY = process.env.DAYTRIP_LOCAL_S3_REPORTS_SECRET_KEY;
exports.S3_VERSIONED_CONTENT_RESOURCES_BUCKET = process.env.DAYTRIP_S3_CONTENT_RESOURCES_BUCKET;
exports.APP_AWS_REGION = "us-east-1";
exports.S3_AWS_REGION = "us-east-1";
exports.GOOGLE_MAPS_API_URL = process.env.DAYTRIP_GOOGLE_MAPS_API_URL;
exports.GOOGLE_MAPS_API_KEY = process.env.DAYTRIP_GOOGLE_MAPS_API_KEY;
exports.GOOGLE_DEFAULT_LANGUAGE = "en";
exports.APPLE_MAPS_SNAPSHOT_ROUTE_DIRECTIONS_ENDPOINT = "/maps/snapshot-directions";
exports.INVOICES_CSV_EXPORT_ENDPOINT = "/invoices-export";
exports.LOGGER_LEVEL = process.env.DAYTRIP_LOGGER_LEVEL || "Debug";
exports.cookies = {
    authentication: `${exports.COOKIE_PREFIX}authenticationToken`,
    refresh: `${exports.COOKIE_PREFIX}refreshToken`,
    isDriversAppAlertHidden: `${exports.COOKIE_PREFIX}isDriversAppAlertHidden`,
    sessionId: `${exports.COOKIE_PREFIX}sessionId`,
};
exports.siteAuthCookies = {
    authentication: `${exports.COOKIE_PREFIX}siteAuthenticationToken`,
    refresh: `${exports.COOKIE_PREFIX}siteRefreshToken`,
};
exports.managementAuthCookies = {
    authentication: `${exports.MANAGEMENT_COOKIE_PREFIX}managementAuthenticationToken`,
    refresh: `${exports.MANAGEMENT_COOKIE_PREFIX}managementRefreshToken`,
};
exports.GCLID_COOKIE_NAME = "gclid";
exports.EUROPEAN_UNION_COUNTRIES_ISO_CODES = [
    "at",
    "be",
    "bg",
    "hr",
    "cy",
    "cz",
    "dk",
    "ee",
    "fi",
    "fr",
    "de",
    "gr",
    "hu",
    "ie",
    "it",
    "lv",
    "lt",
    "lu",
    "mt",
    "nl",
    "pl",
    "pt",
    "ro",
    "sk",
    "si",
    "es",
    "se",
];
exports.EUROPE_COUNTRIES_ISO_CODES = [
    "al",
    "ad",
    "at",
    "by",
    "be",
    "ba",
    "bg",
    "hr",
    "cy",
    "cz",
    "dk",
    "ee",
    "fo",
    "fi",
    "fr",
    "de",
    "gi",
    "gr",
    "hu",
    "is",
    "ie",
    "im",
    "it",
    "rs",
    "lv",
    "li",
    "lt",
    "lu",
    "mk",
    "mt",
    "md",
    "mc",
    "me",
    "nl",
    "no",
    "pl",
    "pt",
    "ro",
    "ru",
    "sm",
    "sk",
    "si",
    "es",
    "se",
    "ch",
    "ua",
    "va",
];
exports.ASIA_COUNTRIES_ISO_CODES = [
    "af",
    "am",
    "az",
    "bh",
    "bd",
    "bt",
    "bn",
    "kh",
    "cn",
    "ge",
    "hk",
    "in",
    "id",
    "ir",
    "iq",
    "il",
    "jp",
    "jo",
    "kz",
    "kw",
    "kg",
    "la",
    "lb",
    "mo",
    "my",
    "mv",
    "mn",
    "mm",
    "np",
    "kp",
    "om",
    "pk",
    "ps",
    "ph",
    "qa",
    "sa",
    "sg",
    "kr",
    "lk",
    "sy",
    "tw",
    "tj",
    "th",
    "tl",
    "tr",
    "tm",
    "ae",
    "uz",
    "vn",
    "ye",
];
exports.SUV_REPLACING_SEDAN_COUNTRIES_ISO_CODES = [
    "ar",
    "bo",
    "cl",
    "co",
    "cr",
    "dz",
    "ec",
    "gt",
    "ma",
    "pa",
    "pe",
];
exports.SUV_REPLACING_SEDAN_COUNTRIES_IDS = [
    "93934583-e8c8-4b86-b0c3-649d30695db5",
    "1426aa90-b116-494c-8b31-3709f25cadd9",
    "0ad324a8-d4e2-4772-ae81-2a6114dc103a",
    "0ccd9691-5334-41c6-ba6e-4a0b05093205",
    "f04473eb-0838-4bf4-8384-81566fcd0c99",
    "2ba85550-7cf8-4df6-a511-124fecdb24da",
    "d8fc6215-8538-4363-b6e0-84416bd1e47a",
    "bf95ff32-b9e3-489d-b672-4ffffb3809e5",
    "edafd1bb-b7ba-4a5e-a196-6c2774afb90f",
    "801bf069-93a8-4ebc-b6e3-c88e79bcc713",
    "8cef8e8a-cd99-4545-87e5-d40c887f8462",
];
exports.EMAIL_ATTEMPTS_THRESHOLD = 5;
exports.FB_DRIVERS_MESSENGER_USERNAME = "daytripdrivers";
exports.constant = {
    cron: "cron",
    servicesSignature: "servicesSignature",
    slack: "slackApi",
    locationBeforeRedirect: "locationBeforeRedirect",
    awss3: "awss3",
    mainS3: "mainS3",
    reportsS3Client: "reportsS3Client",
    settlementsS3Client: "settlementsS3Client",
};
exports.HOME_TIMEZONE = "Europe/Prague";
exports.REDIS_ASSIGNATION_PINS_PREFIX = "assignationPins";
exports.NUMBER_MASKING_DEPARTURE_HOURS_BEFORE = Number(process.env.DAYTRIP_NUMBER_MASKING_DEPARTURE_HOURS_BEFORE || 2);
exports.NUMBER_MASKING_DEPARTURE_HOURS_AFTER = Number(process.env.DAYTRIP_NUMBER_MASKING_DEPARTURE_HOURS_AFTER || 6);
exports.US_COUNTRY_ID = "d803c2ca-0647-4fe7-91d0-7be9f03820b0";
exports.TRAVEL_VOUCHER_DEFAULT_COUNTRY = exports.US_COUNTRY_ID;
exports.FEE_COEFICIENT_BASE = 1;
exports.TRAVEL_VOUCHER_TTL_MONTHS = 24;
exports.GOOGLE_ANALYTICS_ACCOUNT = process.env.DAYTRIP_GOOGLE_ANALYTICS_ACCOUNT;
exports.DEFAULT_BIRTHDAY_AT = Date.UTC(1970, 0, 1, 1, 23);
exports.PENDING_ASSIGNATION_TIME_LIMIT_IN_HOURS = 6;
exports.PENDING_ASSIGNATION_TIME_LIMIT_IN_MS = exports.PENDING_ASSIGNATION_TIME_LIMIT_IN_HOURS * constants_1.HOUR_IN_MILLISECONDS;
exports.PENDING_ASSIGNATION_TIME_LIMIT_PASSED_TEXT = "Offer expired";
exports.ORDER_CHANGEABLE_THRESHOLD_IN_HOURS = 48;
exports.LAST_MINUTE_ORDER_THRESHOLD_IN_HOURS = 36;
exports.CHANGES_CANNOT_BE_GUARANTEED_IN_HOURS = 48;
exports.PRIVATE_BOOKING_PAYMENT_AVAILABILITY_THRESHOLD_IN_HOURS = 3;
exports.POOL_BOOKING_PAYMENT_AVAILABILITY_THRESHOLD_IN_HOURS = 0.5;
exports.POOL_AVAILABILITY_SERVICE_URL = process.env.DAYTRIP_POOL_AVAILABILITY_SERVICE_URL;
exports.POOL_AVAILABILITY_SERVICE_ACCESSTOKEN = process.env.DAYTRIP_POOL_AVAILABILITY_SERVICE_ACCESSTOKEN;
exports.POOL_AVAILABILITY_SERVICE_TIMEOUT = Number(process.env.DAYTRIP_POOL_AVAILABILITY_SERVICE_TIMEOUT);
exports.POOL_AVAILABILITY_SERVICE_RETRIES = Number(process.env.DAYTRIP_POOL_AVAILABILITY_SERVICE_RETRIES);
exports.POOL_AVAILABILITY_SERVICE_BACKOFF = Number(process.env.DAYTRIP_POOL_AVAILABILITY_SERVICE_BACKOFF);
exports.EXCHANGERATESAPI_ACCESS_KEY = process.env.DAYTRIP_EXCHANGERATESAPI_ACCESS_KEY;
exports.MANAGEMENT_GQL_DEBUG_ENABLED = process.env.DAYTRIP_MANAGEMENT_GQL_DEBUG_ENABLED === "true";
exports.MANAGEMENT_GQL_PLAYGROUND_ENABLED = process.env.DAYTRIP_MANAGEMENT_GQL_PLAYGROUND_ENABLED === "true";
exports.ASSIGNATION_PUBLIC_OFFERS_RADIUS_KM = Number(process.env.DAYTRIP_ASSIGNATION_PUBLIC_OFFERS_RADIUS_KM) || 400;
exports.ONESIGNAL_ENABLED = process.env.DAYTRIP_ONESIGNAL_ENABLED === "true" || false;
exports.ONESIGNAL_REST_API_URL = "https://onesignal.com/api/v1";
exports.ONESIGNAL_APP_ID = process.env.DAYTRIP_ONESIGNAL_APP_ID;
exports.ONESIGNAL_REST_API_KEY = process.env.DAYTRIP_ONESIGNAL_REST_API_KEY;
exports.ONESIGNAL_CUSTOMER_APP_APP_ID = process.env.DAYTRIP_ONESIGNAL_CUSTOMER_APP_APP_ID;
exports.ONESIGNAL_CUSTOMER_APP_REST_API_KEY = process.env.DAYTRIP_ONESIGNAL_CUSTOMER_APP_REST_API_KEY;
exports.FEATURE_NEW_COOPERATION_AGREEMENT = process.env.DAYTRIP_FEATURE_NEW_COOPERATION_AGREEMENT === "enabled";
exports.FEATURE_ASSIGNATION_OFFERS_AUTOMATION = process.env.DAYTRIP_FEATURE_ASSIGNATION_OFFERS_AUTOMATION === "enabled" ||
    process.env.DAYTRIP_FEATURE_ASSIGNATION_OFFERS_AUTOMATION === "true";
exports.FEATURE_FORCE_SECURE_MODE_FOR_EUROPE_COUNTRIES = process.env.DAYTRIP_FEATURE_FORCE_SECURE_MODE_FOR_EUROPE_COUNTRIES ===
    "enabled" ||
    process.env.DAYTRIP_FEATURE_FORCE_SECURE_MODE_FOR_EUROPE_COUNTRIES ===
        "true";
exports.FEATURE_EXPOSE_JWT_SIGN_RPC_METHODS = process.env.DAYTRIP_FEATURE_EXPOSE_JWT_SIGN_RPC_METHODS === "enabled" ||
    process.env.DAYTRIP_FEATURE_EXPOSE_JWT_SIGN_RPC_METHODS === "true";
exports.FEATURE_CUSTOMER_TRIP_TRACKING = process.env.DAYTRIP_FEATURE_CUSTOMER_TRIP_TRACKING === "enabled" ||
    process.env.DAYTRIP_FEATURE_CUSTOMER_TRIP_TRACKING === "true";
exports.FEATURE_DRIVER_APP_NEW_DESIGN_GLOBALLY_DISABLED = process.env.DAYTRIP_FEATURE_DRIVER_APP_NEW_DESIGN_GLOBALLY_DISABLED ===
    "true";
exports.FEATURE_RICH_TEXT_SUPPORT = process.env.DAYTRIP_FEATURE_RICH_TEXT_SUPPORT === "enabled" ||
    process.env.DAYTRIP_FEATURE_RICH_TEXT_SUPPORT === "true";
exports.FEATURE_TERMS_AND_CONDITIONS = process.env.DAYTRIP_FEATURE_TERMS_AND_CONDITIONS === "enabled" ||
    process.env.DAYTRIP_FEATURE_TERMS_AND_CONDITIONS === "true";
exports.DAYTRIP_MANAGEMENT_SENTRY_DSN = process.env.DAYTRIP_MANAGEMENT_SENTRY_DSN;
exports.SENTRY_ENABLED = !!process.env.DAYTRIP_SENTRY_ENABLED &&
    global.APPLICATION !== "cron";
exports.SENTRY_DSN = process.env.DAYTRIP_SENTRY_DSN;
exports.SENTRY_ENVIRONMENT = process.env.DAYTRIP_SENTRY_ENVIRONMENT ?? "development";
exports.SENTRY_RPC_SAMPLE_RATE = parseFloat(process.env.DAYTRIP_SENTRY_RPC_SAMPLE_RATE ?? "0.001");
exports.SENTRY_GRAPHQL_SAMPLE_RATE = parseFloat(process.env.DAYTRIP_SENTRY_GRAPHQL_SAMPLE_RATE ?? "0.005");
exports.SENTRY_MNG_GRAPHQL_SAMPLE_RATE = parseFloat(process.env.DAYTRIP_SENTRY_MNG_GRAPHQL_SAMPLE_RATE ?? "0.001");
exports.SENTRY_PAPI_SAMPLE_RATE = parseFloat(process.env.DAYTRIP_SENTRY_PAPI_SAMPLE_RATE ?? "0.0");
exports.DAYTRIP_KLAVIYO_API_KEY = process.env.DAYTRIP_KLAVIYO_API_KEY;
exports.DAYTRIP_KLAVIYO_API_REVISION = process.env.DAYTRIP_KLAVIYO_API_REVISION;
exports.DAYTRIP_KLAVIYO_API_URL = process.env.DAYTRIP_KLAVIYO_API_URL;
exports.DAYTRIP_KLAVIYO_CUSTOMERS_LIST_ID = process.env.DAYTRIP_KLAVIYO_CUSTOMERS_LIST_ID;
exports.DAYTRIP_KLAVIYO_FAMILY_CUSTOMERS_LIST_ID = process.env.DAYTRIP_KLAVIYO_FAMILY_CUSTOMERS_LIST_ID;
exports.ADWORDS_CAMPAIGN_FEED_SECRET_KEY = process.env.DAYTRIP_ADWORDS_CAMPAIGN_FEED_SECRET_KEY;
exports.META_CAMPAIGN_FEED_SECRET_KEY = process.env.DAYTRIP_META_CAMPAIGN_FEED_SECRET_KEY;
exports.ASSIGNATION_OFFER_AUTO_CONFIRMATION_INTERVAL = Number(process.env
    .DAYTRIP_ASSIGNATION_OFFER_AUTO_CONFIRMATION_INTERVAL_IN_SECONDS || 300);
exports.NETHONE_INQUIRIES_URL = process.env.DAYTRIP_NETHONE_INQUIRIES_URL;
exports.NETHONE_TRANSACTIONS_URL = process.env.DAYTRIP_NETHONE_TRANSACTIONS_URL;
exports.NETHONE_BASIC_USER_ID = process.env.DAYTRIP_NETHONE_BASIC_USER_ID;
exports.NETHONE_BASIC_PASSWORD = process.env.DAYTRIP_NETHONE_BASIC_PASSWORD;
exports.RIDE_EMAILS_DISABLED = process.env.DAYTRIP_RIDE_EMAILS_ENABLED !== "true";
exports.PARTNER_API_FLEXIBLE_OFFERS_DISABLED = process.env.DAYTRIP_PARTNER_API_FLEXIBLE_OFFERS_DISABLED === "true";
exports.PARTNERS_WITH_FULL_LITE_SUPPORT = process.env.DAYTRIP_PARTNERS_WITH_FULL_LITE_SUPPORT ?? "";
exports.PARTNERS_WITH_LITE_PRICING_OVERRIDE = process.env.DAYTRIP_PARTNERS_WITH_LITE_PRICING_OVERRIDE ?? "";
exports.BLACKLISTED_API_PARTNERS = process.env.DAYTRIP_BLACKLISTED_API_PARTNERS ?? "";
exports.READONLY_API_PARTNERS = process.env.DAYTRIP_READONLY_API_PARTNERS ?? "";
exports.APPLE_PAY_CHECKOUT_MERCHANT_ID = process.env.DAYTRIP_APPLE_PAY_CHECKOUT_MERCHANT_ID ||
    "merchant.com.cko.daytrip.sandbox";
exports.APPLE_PAY_CHECKOUT_SESSION_CERTIFICATE_KEY = process.env.DAYTRIP_APPLE_PAY_CHECKOUT_SESSION_CERTIFICATE_KEY;
exports.APPLE_PAY_CHECKOUT_SESSION_CERTIFICATE = process.env.DAYTRIP_APPLE_PAY_CHECKOUT_SESSION_CERTIFICATE;
exports.APPLE_PAY_MANGOPAY_MERCHANT_ID = process.env.DAYTRIP_APPLE_PAY_MANGOPAY_MERCHANT_ID;
exports.APPLE_PAY_MANGOPAY_SESSION_CERTIFICATE_KEY = process.env.DAYTRIP_APPLE_PAY_MANGOPAY_SESSION_CERTIFICATE_KEY;
exports.APPLE_PAY_MANGOPAY_SESSION_CERTIFICATE = process.env.DAYTRIP_APPLE_PAY_MANGOPAY_SESSION_CERTIFICATE;
exports.DEFAULT_FEE_COEFFICIENT = parseFloat(process.env.DAYTRIP_DEFAULT_FEE_COEFFICIENT ?? "0.77");
exports.HOURLY_DRIVER_LIMIT_KMS_PER_HOUR = parseInt(process.env.DAYTRIP_HOURLY_DRIVER_LIMIT_KMS_PER_HOUR ?? "20", 10);
exports.MIN_DURATION_HOURS_BOOKING = 1;
exports.MAX_DURATION_HOURS_BOOKING = 24;
exports.ORDER_COMBOS_DISABLED = process.env.DAYTRIP_ORDER_COMBOS_DISABLED === "true";
exports.COMBO_ASSIGNATION_OFFERS_ENABLED = process.env.DAYTRIP_COMBO_ASSIGNATION_OFFERS_ENABLED === "true";
exports.COMBO_MAX_CONNECTION_DISTANCE_KM_CONDITIONAL = parseFloat(process.env.DAYTRIP_COMBO_MAX_CONNECTION_DISTANCE_KM_CONDITIONAL ?? "500");
exports.COMBO_MAX_CONNECTION_DISTANCE_KM_PERMISSIVE = parseFloat(process.env.DAYTRIP_COMBO_MAX_CONNECTION_DISTANCE_KM_PERMISSIVE ?? "100");
exports.COMBO_MIN_SAVINGS_VALUE = parseFloat(process.env.DAYTRIP_COMBO_MIN_SAVINGS_VALUE ?? "40");
exports.LOCKED_COMBO_MIN_SAVINGS_VALUE = parseFloat(process.env.DAYTRIP_LOCKED_COMBO_MIN_SAVINGS_VALUE ?? "1500");
exports.FORCE_COMBO_RECALCULATION_VALUE = parseFloat(process.env.DAYTRIP_FORCE_COMBO_RECALCULATION_VALUE ?? "0.01");
exports.PUBLIC_OFFERS_NOTIFICATION_BATCH_SIZE = parseInt(process.env.DAYTRIP_PUBLIC_OFFERS_NOTIFICATION_BATCH_SIZE ?? "10000");
exports.BASE_ASSIGNATION_OFFERS_DISCOUNT_PERCENTAGE = parseFloat(process.env.DAYTRIP_BASE_ASSIGNATION_OFFERS_DISCOUNT_PERCENTAGE ?? "2");
exports.EARLY_ASSIGNATION_OFFERS_DISCOUNT_PERCENTAGE = parseFloat(process.env.DAYTRIP_EARLY_ASSIGNATION_OFFERS_DISCOUNT_PERCENTAGE ?? "6");
exports.TRIP_DURATION_MAX_DISCOUNT_PERCENTAGE = parseFloat(process.env.DAYTRIP_TRIP_DURATION_MAX_DISCOUNT_PERCENTAGE ?? "5");
exports.AUTO_POST_OFFERS_START_HOUR = parseFloat(process.env.DAYTRIP_AUTO_POST_OFFERS_START_HOUR ?? "18");
exports.MAX_ASSIGNATION_OFFER_REPOST_LIMIT = parseInt(process.env.DAYTRIP_MAX_ASSIGNATION_OFFER_REPOST_LIMIT ?? "2");
exports.MAX_AUTO_AVAILABILITY_CHECK_REPOST_LIMIT = parseInt(process.env.DAYTRIP_MAX_AUTO_AVAILABILITY_CHECK_REPOST_LIMIT ?? "3");
exports.ASSIGNATION_OFFER_REPOST_PRICE_COEFF = parseFloat(process.env.DAYTRIP_ASSIGNATION_OFFER_REPOST_PRICE_COEFF ?? "0.07");
exports.ASSIGNATION_OFFER_AUTO_CANCELLATION_DISABLED = process.env.DAYTRIP_ASSIGNATION_OFFER_AUTO_CANCELLATION_DISABLED === "true";
exports.EARLY_OFFERS_DISABLED = process.env.DAYTRIP_EARLY_OFFERS_DISABLED === "true";
const eoNoPredictionCountries = process.env.DAYTRIP_EARLY_OFFERS_DISABLE_COMBO_PREDICTION_COUNTRIES?.split(",") ?? [];
exports.EARLY_OFFERS_DISABLE_COMBO_PREDICTION_COUNTRIES = eoNoPredictionCountries;
exports.AUTO_PUBLISH_OFFERS_CRON_TIME = process.env.DAYTRIP_AUTO_PUBLISH_OFFERS_CRON_TIME ?? "*/30 * * * * *";
exports.URGENT_OFFERS_REPOST_ENABLED = process.env.DAYTRIP_URGENT_OFFER_REPOST_ENABLED !== "false";
exports.POOL_ASSIGNATION_OFFERS_NOTIFICATIONS_ENABLED = process.env.DAYTRIP_POOL_ASSIGNATION_OFFERS_NOTIFICATIONS_ENABLED ===
    "true";
exports.TRIP_OFFERS_ACCESS_TIME_MULTIPLIER = parseFloat(process.env.DAYTRIP_TRIP_OFFERS_ACCESS_TIME_MULTIPLIER ?? "1");
exports.LATEST_ASSIGNATIONS_FOR_RATING = parseInt(process.env.DAYTRIP_LATEST_ASSIGNATIONS_FOR_RATING ?? "50");
exports.RECALCULATE_INACTIVE_DRIVERS_SCORE = process.env.DAYTRIP_RECALCULATE_INACTIVE_DRIVERS_SCORE === "true";
exports.DRIVER_TRIP_AUTO_CANCELLATION_HOURS_THRESHOLD = parseInt(process.env.DAYTRIP_DRIVER_TRIP_AUTO_CANCELLATION_HOURS_THRESHOLD ?? "96");
exports.TRACKDESK_TENANT_ID = process.env.DAYTRIP_TRACKDESK_TENANT_ID;
exports.TRACKDESK_REVENUE_ORIGIN_ID = process.env.DAYTRIP_TRACKDESK_REVENUE_ORIGIN_ID;
exports.TRACKDESK_API_KEY = process.env.DAYTRIP_TRACKDESK_API_KEY;
exports.HIGH_SUBSIDY_LIMIT = parseInt(process.env.DAYTRIP_HIGH_SUBSIDY_LIMIT ?? "300");
exports.HIGH_COMPENSATION_LIMIT = parseInt(process.env.DAYTRIP_HIGH_COMPENSATION_LIMIT ?? "300");
exports.HIGH_PENALTY_LIMIT = parseInt(process.env.DAYTRIP_HIGH_PENALTY_LIMIT ?? "300");
exports.TAX_ID_PRO_URL = process.env.DAYTRIP_TAX_ID_PRO_URL;
exports.TAX_ID_PRO_API_KEY = process.env.DAYTRIP_TAX_ID_PRO_API_KEY;
exports.VIES_URL = "https://ec.europa.eu/taxation_customs/vies/rest-api";
exports.GOOGLE_SIGN_IN_CLIENT_ID = process.env.DAYTRIP_GOOGLE_SIGN_IN_CLIENT_ID;
exports.CUSTOMER_APP_GOOGLE_SIGN_IN_CLIENT_ID = "207916584136-jnag0c9pe4ecspkr6dmut9teqidj9gpl.apps.googleusercontent.com";
exports.MANAGEMENT_BOT_USER_ID = "6bc4cf56-4e37-4c89-b128-58169336c925";
exports.CUSTOMER_APP_DESIRED_OPTIONAL_VERSION = process.env.DAYTRIP_CUSTOMER_APP_DESIRED_OPTIONAL_VERSION || "0.0.0";
exports.CUSTOMER_APP_DESIRED_REQUIRED_VERSION = process.env.DAYTRIP_CUSTOMER_APP_DESIRED_REQUIRED_VERSION || "0.0.0";
exports.ORDER_DRAFT_EXPIRATION_TIME_IN = process.env.DAYTRIP_ORDER_DRAFT_EXPIRATION_TIME_IN || "24h";
exports.LEGACY_DRIVER_API_URL = process.env.DAYTRIP_LEGACY_DRIVER_API_URL ||
    "https://sandbox.ondaytrip.com/driver/track-a45bc8.php";
exports.AMADEUS_API_KEY = process.env.DAYTRIP_AMADEUS_API_KEY;
exports.AMADEUS_API_SECRET = process.env.DAYTRIP_AMADEUS_API_SECRET;
exports.AMADEUS_API_BASE_URL = process.env.DAYTRIP_AMADEUS_API_BASE_URL || "https://api.amadeus.com";
exports.DATALAYER_API_URL = process.env.DAYTRIP_DATALAYER_API_URL ||
    "https://sgtm.daytrip.com/dev_order_enrichment";
//# sourceMappingURL=config.js.map